import { ConnectionStateCameraStatus, } from '../../../common/interfaces/person-connection';
export const getPlaceholderFromConnectionState = (state) => {
    switch (true) {
        case !state:
            return;
        case !state.hasCamera:
            return 'video-chat.camera.no-device';
        case state.cameraStatus === ConnectionStateCameraStatus.Blocked:
        case state.onlyChat:
            return 'video-chat.camera.blocked';
        case state.cameraStatus === ConnectionStateCameraStatus.Error:
            return 'video-chat.camera.error';
        default:
            return;
    }
};
